import { createStore } from 'vuex'

import { Sections, Diseases, Specialties, Brands, Generics, Cookies, Generic } from './common'
import Analytics from './analytics'
import Access from './access'
import User from './user'
import TableAnalytics from './tableAnalytics'
import Reports from './report'

export default createStore({
    state: {
    },
    getters: {
    },
    actions: {
    },
    mutations: {
    },
    modules: {
        Sections,
        Analytics,
        Diseases,
        Access,
        Cookies,
        Specialties,
        Brands,
        Generics,
        User,
        TableAnalytics,
        Reports,
        Generic
    }
})
